<template>
  <div class="productSystem">
    <div class="main">
      <div class="header">
        <h2>生产系统</h2>
        <div class="headerRight">
          <el-dropdown @command="funSwitch" class="funSwitcher" style="margin-left:0px; text-align: right;">
            <span class="funSwitchBtn" :title="'功能切换：' + currentFunName">
              <i class="iconfont" :class="currentFunIcon"></i>
              {{ currentFunName }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in funList" :key="item.command" :command="item.command">
                <i v-if="item.icon" class="iconfont" :class="item.icon"></i>
                {{ item.name }}
                <i v-if="isActiveFun(item.command)" class="el-icon-check"></i>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-if="userInfo.isAllowLogin"
           class="homeBtn" @click="$router.back()">
            <i class="iconfont icon-shouye"></i>
            主页
          </span >
          <el-dropdown @command="userCommand" class="userDropdown">
            <span class="userName">
              <i class="el-icon-user-solid"></i>
              {{ userInfo.name }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-delete" command="kickOther">踢除其它登录</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="tips tipsBox" v-if="videoSqc">
        <span class="title">操作说明：</span>
        <span class="text">此操作仅适用于老化后的录像检查！</span>
      </div>
      <div class="tips tipsBox" v-else-if="agingCheck">
        <span class="title">操作说明：</span>
        <span class="text">输入SN，选择老化上架或下架后点击按钮提交！</span>
      </div>
      <div class="tips tipsBox" v-else-if="afterRepair">
        <span class="title">操作说明：</span>
        <span class="text">此操作仅适用于维修后的测试前目检【ASSEMBLY_VISUAL】！</span>
      </div>
      <div class="tips tipsBox" v-else-if="renovateDisassemble">
        <span class="title">操作说明：</span>
        <span class="text">拆解旧SN的配件绑定关系，拆解后配件可用于其它主机的生产！</span>
      </div>
      <div class="tips tipsBox" v-else-if="replacePartSn">
        <span class="title">操作说明：</span>
        <span class="text">仅适用于电源适配器和电源线的部件SN更换！</span>
      </div>
      <div class="tips tipsBox" v-else-if="passStation">
        <span class="title">操作说明：</span>
        <span class="text">请选择工单和工序，根据工序SOP完成操作。</span>
      </div>
      <div class="tips tipsBox" v-else-if="snReform">
        <span class="title">操作说明：</span>
        <span class="text">将SN切换成改制后的型号，用于重新生产！</span>
      </div>
      <div v-if="videoSqc" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="sqcForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item key="sn" label="SN" size="small">
            <el-input ref="sqcKey" v-model="sqcForm.sn" placeholder="请输入抽检的SN" clearable
                  @keyup.enter.native="sqcEnterKeydown()">
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="sqcEnterKeydown">录像抽检</el-button>
          </el-form-item>
          <input type="text" id="hiddenInput" style="display:none;">
        </el-form>
        <div class="contentRight">          
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="agingCheck" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="agingCheckForm" class="demo-form-inline" :label-width="labelWidth" @submit.native.prevent>
          <el-form-item key="sn" label="SN" size="small">
            <el-input ref="agingCheckKey" v-model="agingCheckForm.sn" placeholder="请输入抽检的SN" clearable
                  @keyup.enter.native="agingCheckEnterKeydown()">
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="agingCheckEnterKeydown">{{ agingCheckForm.mode === 'on' ? '上架' : '下架' }}</el-button>
          </el-form-item>
          <el-form-item label="类型" size="small">
            <el-radio-group v-model="agingCheckForm.mode">
              <el-radio label="on">老化上架</el-radio>
              <el-radio label="off">老化下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="agingCheckInfo" label=" " size="small">
            <span style="color:var(--textRegular);">工单：{{ agingCheckInfo.orderNumber }}，抽检率：{{ (agingCheckInfo.samplingRate * 100).toFixed(2) }}%</span>
          </el-form-item>
          <input type="text" style="display:none;">
        </el-form>
        <div class="contentRight">          
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="renovateDisassemble" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="renovateForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item key="sn" label="SN" size="small">
            <el-input ref="renovateKey" v-model="renovateForm.key" placeholder="请输入SN" clearable            
                  @keyup.enter.native="renovateEnterKeydown()">
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="renovateEnterKeydown">翻新拆解</el-button>
          </el-form-item>
          <input type="text" id="hiddenInput" style="display:none;">
        </el-form>
        <div class="contentRight">          
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="replacePartSn" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="replacePartForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item key="partType" label="配件类型" size="small">
            <el-select v-model="replacePartForm.partType" placeholder="选择配件类型" filterable clearable>
              <el-option
                v-for="(item, index) in partTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item key="sn" label="产品SN" size="small">
            <el-input ref="replacePartKey" v-model="replacePartForm.sn" placeholder="请输入产品SN" clearable
                  @keyup.enter.native="replacePartNext('sn')">
            </el-input>
          </el-form-item>
          <el-form-item key="partSn" label="旧配件SN" size="small">
            <el-input ref="replacePartPartSn" v-model="replacePartForm.partSn" placeholder="请输入旧配件SN" clearable
                  @keyup.enter.native="replacePartNext('partSn')">
            </el-input>
          </el-form-item>
          <el-form-item key="newPartSn" label="新配件SN" size="small">
            <el-input ref="replacePartNewPartSn" v-model="replacePartForm.newPartSn" placeholder="请输入新配件SN" clearable
                  @keyup.enter.native="replacePartEnterKeydown()">
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="replacePartEnterKeydown">更换配件SN</el-button>
          </el-form-item>
        </el-form>
        <div class="contentRight">          
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="snReform" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="snReformForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item key="productType" label="产品类别" size="small">
            <el-select v-model="snReformForm.productType" placeholder="选择产品类别" filterable clearable @change="snReformProductTypeChange">
              <el-option
                v-for="(item, index) in snReformProductTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item key="oldProductId" label="旧型号" size="small">
            <el-select v-model="snReformForm.oldProductId" placeholder="选择旧型号" filterable clearable>
              <el-option
                v-for="(item, index) in snReformProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item key="newProductId" label="新型号" size="small">
            <el-select v-model="snReformForm.newProductId" placeholder="选择新型号" filterable clearable>
              <el-option
                v-for="(item, index) in snReformProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item key="sn" label="SN" size="small">
            <el-input ref="snReformKey" v-model="snReformForm.sn" placeholder="请输入SN" clearable @keyup.enter.native="snReformSubmit()"></el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="snReformSubmit">改制</el-button>
          </el-form-item>
        </el-form>
        <div class="contentRight">
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="afterRepair" class="content" style="width: 1000px;">
        <el-form :inline="true" :model="repairForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item key="sn" label="SN" size="small">
            <el-input ref="repairKey" v-model="repairForm.key" placeholder="请输入SN" clearable            
                  @keyup.enter.native="repairEnterKeydown()">
            </el-input>
          </el-form-item>
          <el-form-item size="small">
            <el-button type="primary" @click="repairEnterKeydown">维修后目检</el-button>
          </el-form-item>
          <input type="text" id="hiddenInput" style="display:none;">
        </el-form>
        <div class="contentRight">          
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-else-if="passStation" class="content">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" :label-width="labelWidth">
          <el-form-item label="工单号" size="small">
            <el-select v-model="searchForm.orderNumber" filterable placeholder="工单号前五个字符"
              @keyup.enter.native="remoteMethod" :loading="loading"
              @change="orderNumberChange" clearable
              :disabled="isStart"
              :popper-class="proOrderFilterText.length >= 5 ? '' : 'proOrderPullHidden'"
            >
              <el-option
                v-for="item in pullDownData.productOrderList"
                :key="item.id"
                :label="item.orderNumber"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>          
          <el-form-item size="small">
            <el-checkbox :disabled="chkSmtOrder" v-model="smtOrder" class="backBtn">SMT工单</el-checkbox>
          </el-form-item>
          <el-form-item label="线体" size="small">
            <el-cascader
              :options="pullDownData.factoryOrgData"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id',
              }"
              :show-all-levels="false"
              v-model="searchForm.organizationId"
              @change="cascaderChange($event, 'factoryOrgCascader')"
              ref="factoryOrgCascader"
              placeholder="选择所在线体"
              clearable
              :disabled="isStart"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select
              v-model="searchForm.workStationId"
              filterable
              placeholder="选择工序"
              clearable
              :disabled="isStart"
              @change="workStationChange"
            >
              <el-option
                v-for="item in pullDownData.productOrderSopList"
                :key="item.id"
                :label="item.title"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small">
            <el-button v-if="!isStart" type="primary" @click="startProduction"
              :disabled="proOrderDetail ? proOrderDetail.status.code != 'PRODUCTION' : true">开始</el-button>
            <el-button v-else type="primary" @click="endProduction">结束</el-button>
          </el-form-item>
          <div v-if="isStart">
            <el-form-item label="工序配置" size="small">
              <el-radio-group v-model="searchForm.workOptionValue" @change="workOptionChange">
                <el-radio v-for="(item, index) in pullDownData.workStationOptions"
                  :key="index" :label="item.name || 'key'">{{ item.title }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <div class="tips tipsBox" if="searchForm.workOptionValue">
              <span class="title">操作说明：</span>
              <span class="text">{{ tipText }}</span>
            </div>
            <div v-if="searchForm.workOptionValue && pullDownData.SNOption.length != 0"
              :key="searchForm.workOptionValue">
              <el-form-item v-for="(item, index) in pullDownData.SNOption" :key="index" :label="item && item.title ? item.title : ''" size="small">
                <el-input v-if="item && item.type == 'text_box'" class="SNinput" clearable
                  :ref="item.name" :placeholder="`请输入${item.title}`" v-model="searchForm[item.name]"
                  @keyup.enter.native="SNOptionKeydown(item, index)">
                </el-input>
                <el-input v-else-if="item && item.type == 'text_area'" type="textarea" :rows="item.rows" class="textarea"
                  :ref="item.name" :autosize="{minRows: 3, maxRows: 5}" :placeholder="`请输入${item.title}`"
                  v-model="searchForm[item.name]" @keyup.enter.native="SNOptionKeydown(item, index)"
                ></el-input>
              </el-form-item>
              <el-form-item v-if="pullDownData.uploadLog" label="附件Fid" size="small">
                <el-input class="SNinput" clearable
                  :ref="searchForm.fid" :placeholder="`附件fid(请先上传文件获取fid)`" v-model="searchForm.fid">
                </el-input>
              </el-form-item>
              <el-form-item size="small">
                <el-button type="primary" @click="bindBtn(0)">{{bindBtnText}}</el-button>
                <el-button type="danger" v-if="failButtonText" @click="bindBtn(1)">{{failButtonText}}</el-button>
                <el-button type="warning" v-if="buttonText2" @click="bindBtn(2)">{{buttonText2}}</el-button>
                <el-button type="primary" v-if="againSN && printTagValue" @click="againPrint">重新打印</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="contentRight">
          <div class="proOrderDetail" v-if="proOrderDetail">
            <div>
              <p class="title">型号：</p>
              {{ proOrderDetail.product.code }}
            </div>
            <div>
              <p class="title">销售订单：</p>
              {{ proOrderDetail.customerOrder ? proOrderDetail.customerOrder.orderNumber : "-"}}
            </div>
            <div>
              <p class="title">数量：</p>
              {{ proOrderDetail.quantity }}PCS
            </div>
            <div>
              <p class="title">状态：</p>
              {{ proOrderDetail.status.title }}
            </div>
          </div>
          <div class="printTagBox">
            <el-checkbox v-model="printTagValue" :disabled="isStart"
              >打印标签</el-checkbox
            >
          </div>
          <div v-if="bindStatus" class="statusBox" :class="[bindStatus == 'PASS' ? 'pass' : 'fail']">
            {{ bindStatus }}
          </div>
        </div>
      </div>
      <div v-if="bindMsg" style="padding-left:10px;padding-bottom:10px;background-color:var(--tipsBg);">
        <span :class="[bindStatus == 'PASS' ? 'pass1' : 'fail1']">{{ bindMsg }}</span>
      </div>
      <div class="tableBox">
        <el-table stripe :data="bindSNData" height="100%" border size="mini">
          <el-table-column label="时间" align="center">">
            <template slot-scope="scope">{{scope.row.dateTime}}</template>
          </el-table-column>
          <el-table-column v-if="videoSqc || agingCheck || afterRepair || renovateDisassemble || snReform" label="SN" align="center">">
            <template slot-scope="scope">{{scope.row.sn ? scope.row.sn : '-'}}</template>
          </el-table-column>
          <el-table-column v-if="snReform" label="旧型号" align="center">
            <template slot-scope="scope">{{scope.row.oldProductName ? scope.row.oldProductName : '-'}}</template>
          </el-table-column>
          <el-table-column v-if="snReform" label="新型号" align="center">
            <template slot-scope="scope">{{scope.row.newProductName ? scope.row.newProductName : '-'}}</template>
          </el-table-column>
          <el-table-column v-for="(item, index) in tableRow" align="center"
            :key="index" :prop="item.prop" :label="item.label">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row[item.prop]" class="item" effect="dark" :content="scope.row[item.prop]" placement="top" min-width="110px" :open-delay="300">
                <div class="textOverflow" :style="{color: scope.row.code ? '#F56C6C' : ''}">{{scope.row[item.prop]}}</div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="错误代码" prop="code" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.msg" placement="top" :open-delay="300">
                <span :style="{ color: scope.row.code ? '#F56C6C' : '' }">{{scope.row.code}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      class="myDialog qcDialog"
      title="二维码"
      :visible.sync="qcDialogVisible"
      width="400px"
      top="50vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-dialogDrag
      >
      <div ref="qrcodeRef" id="qrcodeId" class="qrcode" ></div>
    </el-dialog>
    <myDialog
      title="修改用户密码"
      ref="myDialog"
      width="400px"
      @submitData="submitData"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          ref="passwordForm"
          :model="passwordForm"
          :rules="passwordRules"
          label-width="90px"
        >
          <el-form-item label="旧密码：" size="small" prop="oldPassword">
            <el-input
              type="password"
              v-model="passwordForm.oldPassword"
              placeholder="请输入当前账号密码"
              clearable
              show-password
              @keyup.enter.native="$refs.password.focus"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码：" size="small" prop="password">
            <el-input
              ref="password"
              type="password"
              v-model="passwordForm.password"
              placeholder="请输入新密码"
              clearable
              @keyup.enter.native="$refs.againPwd.focus"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" size="small" prop="againPwd">
            <el-input
              ref="againPwd"
              type="password"
              v-model="passwordForm.againPwd"
              placeholder="请再次输入新密码"
              clearable
              @keyup.enter.native="submitData('修改用户密码')"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {
  apiFactoryOrgShow,
  apiProductionOrderList,
  apiSmtOrderList,
  apiSmtOrderSopList,
  apiSmtOrderDetail,
  apiProductionOrderDetail,
  apiProductionOrderSopList,
  apiWorkProcess,
  apiSqcVideo,
  apiSqcAgingOn,
  apiSqcAgingOff,
  apiAipcAfterRepairVisual,
  apiAipcRenovateDisassemble,
  apiReplacePartSnForce,
  apiPartTypeList
} from "@/api/productSystem.js";
import {
  apiProductTypeList as apiSnReformProductTypeList,
  apiProductList as apiSnReformProductList,
  apiUpdateProductModel
} from "@/api/deviceManage.js";
import axios from "axios";
import { apiUserLogout, apiUserChangePassword, apiKickOutOtherLogins } from "@/api/userApi.js";
import myDialog from "@/components/myDialog.vue";
import { removeLocalStorage, removeSessionStorage } from "@/utils/myStorage.js";
import QRCode  from "qrcodejs2"
export default {
  components: {
    myDialog
  },
  computed : {
    bindBtnText() {
      if (this.videoSqc) {
        return "录像抽检";
      }
      if (this.afterRepair) {
        return "维修后目检";
      }
      if (this.renovateDisassemble) {
        return "翻新拆解";
      }
      if (this.replacePartSn) {
        return "更换配件SN";
      }
      return this.pullDownData.workStationOptions[0].button || "PASS"
    },
    buttonText2() {
      return this.pullDownData.workStationOptions[0].button2
    },
    failButtonText() {
      return this.pullDownData.workStationOptions[0].failButton
    },
    // 当前激活功能名（触发器图标后文字显示 + 悬停 title 提示）
    currentFunName() {
      const active = this.funList.find(item => this[item.command]);
      return active ? active.name : "";
    },
    // 当前激活功能图标（触发器图标随菜单切换动态变化，无激活项时回退产品与服务图标）
    currentFunIcon() {
      const active = this.funList.find(item => this[item.command]);
      return active && active.icon ? active.icon : "icon-chanpinyufuwu";
    }
  },
  data() {
    return {
      // 功能切换菜单项（过站工序/TF卡录像检查/老化抽检/维修后目检/翻新拆解/更换配件SN/SN改制，七功能互斥）
      funList: [
        { command: "passStation", name: "过站工序", icon: "icon-saomaguozhan" },
        { command: "videoSqc", name: "TF卡录像检查", icon: "icon-tfneicunkatubiao" },
        { command: "agingCheck", name: "老化抽检", icon: "icon-laohuaceshi" },
        { command: "afterRepair", name: "维修后目检", icon: "icon-chakan" },
        { command: "renovateDisassemble", name: "翻新拆解", icon: "icon-jiebang" },
        { command: "replacePartSn", name: "更换配件SN", icon: "icon-genghuan" },
        { command: "snReform", name: "SN改制", icon: "icon-zuzhiqiehuan" }
      ],
      videoSqc: false,
      agingCheck: false,
      afterRepair: false,
      renovateDisassemble: false,
      replacePartSn: false,
      snReform: false,
      // 过站工序：默认选中，对应默认生产内容区（工单号/线体/工序）
      passStation: true,
      smtOrder: false,
      chkSmtOrder: false,
      userInfo: {},
      // 修改密码弹框
      passwordForm: {},
      passwordRules: {
        oldPassword: [
          { required: true, message: "当前账号密码不能为空！", trigger: "blur" },
          { min: 6, max: 64, message: "长度在 6 到 64 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, message: "新密码不能为空！", trigger: "blur" },
          { min: 6, max: 64, message: "长度在 6 到 64 个字符", trigger: "blur" }
        ],
        againPwd: [
          { required: true, message: "确认密码不能为空！", trigger: "blur" },
          { min: 6, max: 64, message: "长度在 6 到 64 个字符", trigger: "blur" }
        ]
      },
      tipText: "",
      searchForm: {},
      repairForm:{},
      renovateForm:{},
      replacePartForm:{},
      sqcForm:{},
      // 老化抽检表单（预声明完整结构，避免 Vue 2 响应式检测问题）
      agingCheckForm: { sn: '', mode: 'on' },
      // 老化抽检返回数据（工单/抽检率等）
      agingCheckInfo: null,
      labelWidth: "110px",
      partTypeList: [],
      pullDownData: {
        factoryOrgData: [],
        productOrderList: [],
        productOrderSopList: [],
        workStationOptions: [],
        SNOption: [],
      },
      proOrderFilterText: "",
      loading: false,
      proOrderDetail: null,
      printTagValue: false,
      isStart: false,
      // 组装工单延时加载
      timer: "",
      bindStatus: null,
      bindMsg: null,
      // 重新打印sn
      againSN: "",
      // 已绑定sn表格
      bindSNData: [],
      // 表格列
      tableRow: [
        {
          label: "类别",
          prop: "type",
        },
      ],
      // 二维码数据
      QCData: "",
      qcDialogVisible: false,
      // SN改制表单（预声明完整结构，避免 Vue 2 响应式检测问题）
      snReformForm: { productType: null, oldProductId: null, newProductId: null, sn: '' },
      // SN改制下拉数据
      snReformProductTypeList: [],
      snReformProductList: [],
      // SN改制执行结果（复用公共 bindSNData 表格，与其它功能统一显示在下方）
    };
  },
  methods: {
    // 功能切换菜单：判断菜单项是否为当前激活功能（显示对勾）
    isActiveFun(command) {
      return this[command];
    },
    // 功能切换：六个功能互斥，选中项置为唯一激活态（SN改制 已并入菜单，统一走此方法）
    funSwitch(command) {
      this.funList.forEach(item => {
        this[item.command] = item.command === command;
      });
      this.bindStatus = null;
      this.bindSNData = [];
      this.agingCheckInfo = null;
      // 记住当前选择的功能项
      localStorage.setItem('productSystemFun', command);
      // 切换到特定功能时聚焦SN输入框
      if (command === 'snReform') {
        this.$nextTick(() => {
          this.$refs.snReformKey && this.$refs.snReformKey.focus();
        });
      }
      if (command === 'agingCheck') {
        this.$nextTick(() => {
          this.$refs.agingCheckKey && this.$refs.agingCheckKey.focus();
        });
      }
    },
    // 线体
    async getFactoryOrg() {
      const res = await apiFactoryOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.pullDownData.factoryOrgData = res.data.children;
      }
    },
    // 配件类型
    async getPartTypeList() {
      const res = await apiPartTypeList();
      if (res.code == 0) {
        this.partTypeList = res.data;
      }
    },
    // SN改制--产品类别下拉数据
    async getSnReformProductTypeList() {
      const res = await apiSnReformProductTypeList();
      if (res.code == 0) {
        this.snReformProductTypeList = res.data;
      }
    },
    // SN改制--产品类别改变，联动加载产品型号
    snReformProductTypeChange(value) {
      this.snReformForm.oldProductId = null;
      this.snReformForm.newProductId = null;
      this.snReformProductList = [];
      if (value) {
        this.getSnReformProductList(value);
      }
    },
    // SN改制--产品型号下拉数据
    async getSnReformProductList(productType) {
      const res = await apiSnReformProductList({ productType });
      if (res.code == 0) {
        this.snReformProductList = res.data;
      }
    },
    // SN改制--提交
    async snReformSubmit() {
      if (!this.snReformForm.productType) {
        this.$message({ type: 'warning', message: '请选择产品类别！' });
        return;
      }
      if (!this.snReformForm.oldProductId) {
        this.$message({ type: 'warning', message: '请选择旧型号！' });
        return;
      }
      if (!this.snReformForm.newProductId) {
        this.$message({ type: 'warning', message: '请选择新型号！' });
        return;
      }
      if (!this.snReformForm.sn || !this.snReformForm.sn.trim()) {
        this.$message({ type: 'warning', message: '【SN】不能为空！' });
        return;
      }
      const res = await apiUpdateProductModel({
        newProductId: this.snReformForm.newProductId,
        oldProductId: this.snReformForm.oldProductId,
        sn: this.snReformForm.sn.trim()
      });
      this.getSnReformData(res);
      if (res.code == 0) {
        this.$message({ type: 'success', message: res.msg || 'SN改制成功' });
        this.bindStatus = 'PASS';
        this.bindMsg = res.msg;
        // 保留产品类别、旧型号、新型号，仅清空 SN
        this.snReformForm = { productType: this.snReformForm.productType, oldProductId: this.snReformForm.oldProductId, newProductId: this.snReformForm.newProductId, sn: '' };
      } else {
        this.bindStatus = 'FAIL';
        this.bindMsg = res.msg;
      }
      this.$refs.snReformKey.focus();
      this.$refs.snReformKey.select();
    },
    // 记录SN改制执行结果
    getSnReformData(res) {
      let oldProductName = '';
      let newProductName = '';
      this.snReformProductList.forEach((item) => {
        if (item.id == this.snReformForm.oldProductId) {
          oldProductName = item.name;
        }
        if (item.id == this.snReformForm.newProductId) {
          newProductName = item.name;
        }
      });
      this.bindSNData.unshift({
        dateTime: new Date().toLocaleString(),
        type: 'SN改制',
        sn: this.snReformForm.sn,
        oldProductName: oldProductName,
        newProductName: newProductName,
        code: res.code,
        msg: res.msg
      });
    },
    // 组装工单数据请求
    async remoteMethod(e) {
      let query = e.target.value;
      this.proOrderFilterText = query;
      if (query.length >= 5 && !this.loading) {
        this.loading = true;        
          if (this.smtOrder) {
            const res = await apiSmtOrderList({
              orderNumber: query
            });
            if (res.code == 0) {
              this.loading = false;
              this.pullDownData.productOrderList = res.data;
            }
          } else {
            const res = await apiProductionOrderList({
              orderNumber: query,
              status: ["PRODUCTION"],
            });
            if (res.code == 0) {
              this.loading = false;
              this.pullDownData.productOrderList = res.data;
            }
        }
      } else {
        this.loading = false;
        this.pullDownData.productOrderList = [];
      }
    },
    // 组装工单改变
    orderNumberChange(value) {
      if (value) {
        this.getOrderSoplist(value);
        this.getProductionOrderDetail(value);
      } else {
        this.proOrderDetail = null;
        this.pullDownData.productOrderList = [];
        this.pullDownData.productOrderSopList = [];
      }
      this.$set(this.searchForm, "workStationId", undefined);
    },
    // 工单订单详情
    async getProductionOrderDetail(value) {
      this.chkSmtOrder = true;
      if (this.smtOrder) {
        const res = await apiSmtOrderDetail({
          id: value,
        });
        // console.log(res);
        if (res.code == 0) {
          this.data = res.data;
          this.proOrderDetail = res.data;
        }
      } else {
        const res = await apiProductionOrderDetail({
          id: value,
        });
        // console.log(res);
        if (res.code == 0) {
          this.data = res.data;
          this.proOrderDetail = res.data;
        }
      }
    },
    // 工序SOP数据请求
    async getOrderSoplist(value) {
      if (this.smtOrder) {
        const res = await apiSmtOrderSopList({
          orderId: value,
        });
        if (res.code == 0) {
          this.pullDownData.productOrderSopList = res.data;
        }
      } else {
        const res = await apiProductionOrderSopList({
          orderId: value,
        });
        if (res.code == 0) {
          this.pullDownData.productOrderSopList = res.data;
        }
      }
    },
    // 工序改变
    workStationChange(value) {
      if (value) {
        this.pullDownData.productOrderSopList.forEach((item) => {
          if (item.workStation.id == value) {
            this.pullDownData.workStationOptions = item.workStationOptions;
            this.pullDownData.uploadLog = item.uploadLog;
            this.printTagValue = (item.labelType!=null);
          }
        });
      } else {
        this.$set(this.searchForm, "workStationId", undefined);
      }
    },
    // 开始
    startProduction() {
      // 条件为空判断
      if (!this.searchForm.orderNumber) {
        this.$message({
          type: "warning",
          message: "组装工单不能为空！",
        });
        return;
      } else if (!this.searchForm.organizationId) {
        this.$message({
          type: "warning",
          message: "线体不能为空！",
        });
        return;
      } else if (!this.searchForm.workStationId) {
        this.$message({
          type: "warning",
          message: "工序不能为空！",
        });
        return;
      }
      if (this.printTagValue) {
        axios
          .get("http://127.0.0.1:8888/AoniPrinterServerApi/Printer/Test")
          .then((res) => {
            if (res.data.code == 0) {
              this.isStart = !this.isStart;
            } else {
              this.$message({
                type: "error",
                message: "打印机返回：" + res.data.msg,
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "打印机连接失败，请检查网络连接",
            });
          });
      } else {
        this.isStart = !this.isStart;
      }
    },
    // 结束
    endProduction() {
      this.isStart = !this.isStart;
      this.$set(this.searchForm, "workOptionValue", undefined);
      this.pullDownData.SNOption.forEach((item) => {
        if (item.name) {
          this.$set(this.searchForm, item.name, undefined);
        }
      });
      this.$set(this.searchForm, "data", undefined);
      this.bindStatus = null;
      this.bindMsg = null;
      this.bindSNData = [];
      this.tableRow = [
        {
          label: "类别",
          prop: "type",
        },
      ];
      this.againSN = "";
    },
    // 工序配置单选改变
    workOptionChange(value) {
      this.pullDownData.workStationOptions.forEach((item) => {
        if (item.name == value) {
          this.tipText = item.tips;
          if (item.options && item.key) {
            this.pullDownData.SNOption = [item.key, ...item.options]
          } else {
            this.pullDownData.SNOption = item.options || [item.key] || [];
          }
          this.$set(this.searchForm, "data", undefined);
          this.bindStatus = null;
          this.bindMsg = null;
          // 表格列数
          if (this.tableRow.length == 1) {
            this.pullDownData.SNOption.forEach((item) => {
              if (item && item.title) {
                this.tableRow.push({
                  label: item.title,
                  prop: item.name,
                });
              }
            });
          }
          this.againSN = "";
        }
      });
    },
    replacePartNext(currentField) {
      let fieldMap = {
        'sn': { next: 'replacePartPartSn', msg: '【产品SN】不能为空！' },
        'partSn': { next: 'replacePartNewPartSn', msg: '【旧配件SN】不能为空！' }
      };
      let cfg = fieldMap[currentField];
      let val = this.replacePartForm[currentField] ? this.replacePartForm[currentField].trim() : '';
      if (!val) {
        this.$message({ type: 'warning', message: cfg.msg });
        return;
      }
      this.$refs[cfg.next].focus();
      this.$refs[cfg.next].select();
    },
    replacePartEnterKeydown() {
      if (!this.replacePartForm.sn || !this.replacePartForm.partSn || !this.replacePartForm.newPartSn) {
        this.$message({ type: 'warning', message: '所有SN不能为空！' });
        return;
      }
      let sn = this.replacePartForm.sn.trim();
      let partSn = this.replacePartForm.partSn.trim();
      let newPartSn = this.replacePartForm.newPartSn.trim();
      if (!sn || !partSn || !newPartSn) {
        this.$message({ type: 'warning', message: '所有SN不能为空！' });
        return;
      }
      this.replacePartSubmit();
    },
    async replacePartSubmit() {
      let res = await apiReplacePartSnForce({
        sn: this.replacePartForm.sn,
        partType: this.replacePartForm.partType,
        partSn: this.replacePartForm.partSn,
        newPartSn: this.replacePartForm.newPartSn,
      });
      if (res.code == 0) {
        this.$message({ type: 'success', message: res.msg || '更换配件SN成功' });
        this.getBindSNData(res);
        this.bindStatus = 'PASS';
        this.bindMsg = res.msg;
        this.replacePartForm = {};
        this.$refs.replacePartKey.focus();
        this.$refs.replacePartKey.select();
      } else {
        this.bindStatus = 'FAIL';
        this.bindMsg = res.msg;
        this.getBindSNData(res);
        this.$refs.replacePartKey.focus();
        this.$refs.replacePartKey.select();
      }
    },
    async renovateSubmit() {
      let res = await apiAipcRenovateDisassemble({
        ...this.renovateForm,
      });
      if (res.code == 0) {        
        this.$message({
          type: "success",
          message: `${this.bindBtnText}成功`,
        })
        if(res.data && res.data.serialNumber) {
          this.$set(this.searchForm, this.tableRow[1].prop, res.data.serialNumber)
        }
        this.getBindSNData(res);
        this.successClear();
        this.bindStatus = "PASS";
        this.bindMsg = res.msg;
        
        this.$refs.renovateKey.focus();
        this.$refs.renovateKey.select();
      } else {
        this.bindStatus = "FAIL";
        this.bindMsg = res.msg;
        this.getBindSNData(res);
        
        this.$refs.renovateKey.focus();
        this.$refs.renovateKey.select();
      }
    },
    renovateEnterKeydown() {
      if (!this.renovateForm.key) {
        return;
      }
      let tmp = this.renovateForm.key.trim();
      if (!tmp || tmp=="") {
        this.$message({
          type: "warning",
          message: `【SN】不能为空！`,
        });
        return;
      }
      if (tmp.startsWith("*AIPC_") && tmp.endsWith("*")) {
        this.$prompt('请扫描产品标签', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(async({ value }) => {
          this.renovateForm["errorCode"] = this.renovateForm["key"];
          this.renovateForm["key"] = value;
          setTimeout(() => {
            this.renovateForm["errorCode"]=null;
          }, 1000);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
          return;
        });
      } else {
        this.renovateSubmit();
      }
    },
    async repairSubmit() {
      let res = await apiAipcAfterRepairVisual({
        ...this.repairForm,
      });
      if (res.code == 0) {        
        this.$message({
          type: "success",
          message: `${this.bindBtnText}成功`,
        })
        if(res.data && res.data.serialNumber) {
          this.$set(this.searchForm, this.tableRow[1].prop, res.data.serialNumber)
        }
        this.getBindSNData(res);
        this.successClear();
        this.bindStatus = "PASS";
        this.bindMsg = res.msg;
        
        this.$refs.repairKey.focus();
        this.$refs.repairKey.select();
      } else {
        this.bindStatus = "FAIL";
        this.bindMsg = res.msg;
        this.getBindSNData(res);
        
        this.$refs.repairKey.focus();
        this.$refs.repairKey.select();
      }
    },
    async sqcSubmit() {
      let res = await apiSqcVideo({
        ...this.sqcForm,
      });
      if (res.code == 0) {        
        this.$message({
          type: "success",
          message: `${this.bindBtnText}完成`,
        })
        if(res.data && res.data.serialNumber) {
          this.$set(this.searchForm, this.tableRow[1].prop, res.data.serialNumber)
        }
        this.getBindSNData(res);
        this.successClear();
        this.bindStatus = "PASS";
        this.bindMsg = res.msg;
        
        this.$refs.sqcKey.focus();
        this.$refs.sqcKey.select();
      } else {
        this.bindStatus = "FAIL";
        this.bindMsg = res.msg;
        this.getBindSNData(res);
        
        this.$refs.sqcKey.focus();
        this.$refs.sqcKey.select();
      }
    },
    sqcEnterKeydown() {
      if (!this.sqcForm.sn) {
        return;
      }
      let tmp = this.sqcForm.sn.trim();
      if (!tmp || tmp=="") {
        this.$message({
          type: "warning",
          message: `【SN】不能为空！`,
        });
        return;
      }
      
      this.sqcSubmit();
    },
    // 老化抽检--回车校验
    agingCheckEnterKeydown() {
      if (!this.agingCheckForm.sn) {
        return;
      }
      let tmp = this.agingCheckForm.sn.trim();
      if (!tmp || tmp === '') {
        this.$message({
          type: 'warning',
          message: '【SN】不能为空！',
        });
        return;
      }
      this.agingCheckSubmit();
    },
    // 老化抽检--提交（上架/下架共用，根据 mode 调用不同 API）
    async agingCheckSubmit() {
      const apiFn = this.agingCheckForm.mode === 'on' ? apiSqcAgingOn : apiSqcAgingOff;
      let res = await apiFn({ sn: this.agingCheckForm.sn.trim() });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: res.msg || '老化抽检完成',
        });
        this.getBindSNData(res);
        this.bindStatus = 'PASS';
        this.bindMsg = res.msg;
        this.agingCheckInfo = res.data || null;
        this.agingCheckForm.sn = '';
        this.$refs.agingCheckKey.focus();
        this.$refs.agingCheckKey.select();
      } else {
        this.bindStatus = 'FAIL';
        this.bindMsg = res.msg;
        this.getBindSNData(res);
        this.$refs.agingCheckKey.focus();
        this.$refs.agingCheckKey.select();
      }
    },
    repairEnterKeydown() {
      if (!this.repairForm.key) {
        return;
      }
      let tmp = this.repairForm.key.trim();
      if (!tmp || tmp=="") {
        this.$message({
          type: "warning",
          message: `【SN】不能为空！`,
        });
        return;
      }
      if (tmp.startsWith("*AIPC_") && tmp.endsWith("*")) {
        this.$prompt('请扫描产品标签', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(async({ value }) => {
          // 交换key和错误代码
          this.repairForm["errorCode"] = this.repairForm["key"];
          this.repairForm["key"] = value;
          // 延时移除异常代码，避免回车重复提交
          setTimeout(() => {
            this.repairForm["errorCode"]=null;
          }, 1000);
          // this.repairSubmit();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
          return;
        });
      } else {
        this.repairSubmit();
      }
    },
    // sn输入框回车
    SNOptionKeydown(item, index) {
      let tmp = this.searchForm[item.name].trim();
      if (item.required && (!tmp || tmp=="")) {
        this.$message({
          type: "warning",
          message: `${item.title}不能为空`,
        });
        return;
      }
      if (item.type=='text_area') {
        let lines = tmp.split(/\r*\n/);
        let linesCount = lines.length - (navigator.userAgent.indexOf('MSIE') !== -1);
        if (linesCount < event.target.rows) {
          return;
        } else {
          this.searchForm[item.name] = tmp;
        }
      }
      if (item.name=='key' && tmp.startsWith("*AIPC_") && tmp.endsWith("*")) {
        this.$prompt('请扫描产品标签', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(async({ value }) => {
          let SNOption = this.pullDownData.SNOption;
          if (index == SNOption.length - 1) {
            // 交换key和错误代码
            this.searchForm["errorCode"] = this.searchForm["key"];
            this.searchForm["key"] = value;
            if (!this.pullDownData.workStationOptions[0].button2 && !this.pullDownData.workStationOptions[0].failButton) {
              this.bindBtn(1, index);
              // 延时移除异常代码，避免回车重复提交
              setTimeout(() => {
                this.searchForm["errorCode"]=null;
              }, 1000);
            }
          } else {
            this.$refs[SNOption[index + 1].name][0].focus();
            this.$refs[SNOption[index + 1].name][0].select();
            this.bindStatus = null;
            this.bindMsg = null;
          }   
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      } else if (!this.searchForm["errorCode"]) {
        let SNOption = this.pullDownData.SNOption;
        if (index == SNOption.length - 1) {
          if (!this.pullDownData.workStationOptions[0].button2 && !this.pullDownData.workStationOptions[0].failButton) {
            this.bindBtn(0, index);
          }
        } else {
          this.$refs[SNOption[index + 1].name][0].focus();
          this.$refs[SNOption[index + 1].name][0].select();
          this.bindStatus = null;
          this.bindMsg = null;
        }        
      }
    },
    // PASS按钮
    async bindBtn(code, index) {
      let SNOption = this.pullDownData.SNOption;
      for (let i = 0; i < SNOption.length; i++) {
        if (SNOption[i] && SNOption[i].required && !(this.searchForm[SNOption[i].name])) {
          this.$message({
            type: "warning",
            message: `${SNOption[i].title}不能为空`,
          });
          return;
        }
      }
      let dataOption = {};
      SNOption.forEach((item) => {
        if (item) {
          if(item.array) {
            // 行转数组
            const lines = this.searchForm[item.name].split("\n");
            dataOption[item.name] = lines;
          } else {
            dataOption[item.name] = this.searchForm[item.name];
          }
        }
      });
      if(this.searchForm["errorCode"]) {
        dataOption.errorCode = this.searchForm["errorCode"];
      }
      
      if (SNOption[0]) {
        dataOption.partName = this.searchForm.workOptionValue;
      }
      let dataString = JSON.stringify(dataOption);
      let res = {};
      if (this.searchForm.fid) {
        dataOption.fid = this.searchForm.fid;
      }
      if('key' in this.pullDownData.workStationOptions[0]) {
        res = await apiWorkProcess({
          organizationId: this.searchForm.organizationId,
          orderId: this.searchForm.orderNumber,
          workStationId: this.searchForm.workStationId,
          code:code,
          data: dataString,
          orderType: (this.smtOrder ? 6 : 0),
          ...dataOption
        });
      } else {
        this.$set(this.searchForm, "data", JSON.stringify(dataOption));
        res = await apiWorkProcess({
          organizationId: this.searchForm.organizationId,
          orderId: this.searchForm.orderNumber,
          workStationId: this.searchForm.workStationId,
          data: this.searchForm.data,
          fid: this.searchForm.fid,
          orderType: (this.smtOrder ? 6 : 0),
          ...dataOption
        });
      }
      if (res.code == 0) {
        if (this.printTagValue) {
          this.printServer(res.data);
        } else {
          if(res.qrCode) {
            this.QCData = JSON.stringify(res.data);
            this.qcDialogVisible = true;
            this.$nextTick (function () {
              this.createQrcode();
            })
          } else {
            this.$message({
              type: "success",
              message: `${this.bindBtnText}成功`,
            })
          }
          if(res.data && res.data.serialNumber) {
            this.$set(this.searchForm, this.tableRow[1].prop, res.data.serialNumber)
          }
          this.getBindSNData(res);
          this.successClear();
        }
        this.bindStatus = "PASS";
        this.bindMsg = res.msg;
        
        this.$refs[SNOption[0].name][0].focus();
        this.$refs[SNOption[0].name][0].select();
      } else {
        this.bindStatus = "FAIL";
        this.bindMsg = res.msg;
        if (SNOption[0]) {
          if (!index) {
            this.$refs[SNOption[0].name][0].focus();
            this.$refs[SNOption[0].name][0].select();
          } else {
            this.$refs[SNOption[index].name][0].focus();
            this.$refs[SNOption[index].name][0].select();
          }
        }
        this.getBindSNData(res);
        // this.successClear();
      }
    },
    // 重新打印
    againPrint() {
      this.printServer(this.againSN);
    },
    // 打印服务器
    async printServer(sn) {
      const res = await axios({
        method: "get",
        url: "http://127.0.0.1:8888/AoniPrinterServerApi/TWS/Shell/",
        params: { sn },
      }).catch(() => {
        this.$message({
          type: "error",
          message: "检测不到打印机，请开启打印机服务器",
        });
        this.againSN = sn;
        return false;
      });
      if (!res) return;
      if (res.data.code == 0) {
        this.getBindSNData(res);
        this.successClear();
        this.$message({
          type: "success",
          message: `打印机返回：${res.data.msg}`,
        });
      } else if (res.data.code == 500) {
        this.$message({
          type: "warning",
          message: `打印机返回：${res.data.msg}`,
        });
      } else {
        this.$message({
          type: "warning",
          message: `打印机可能卡死, 请重开打印机重新打印`,
        });
        this.againSN = sn;
      }
    },
    // 表格数据
    getBindSNData(res) {
      // 类别列的显示值
      let typeName = "";
      if (this.videoSqc) {
        this.searchForm.sn = this.sqcForm.sn;
        typeName = "录像抽检";
      } else if(this.agingCheck) {
        this.searchForm.sn = this.agingCheckForm.sn;
        typeName = this.agingCheckForm.mode === 'on' ? '老化上架' : '老化下架';
      } else if(this.afterRepair) {
        this.searchForm.sn = this.repairForm.key;
        typeName = "维修后目检";
      } else if(this.renovateDisassemble) {
        this.searchForm.sn = this.renovateForm.key;
        typeName = "翻新拆解";
      } else if(this.replacePartSn) {
        this.searchForm.sn = this.replacePartForm.sn;
        typeName = "更换配件SN";
      } else {
        this.pullDownData.workStationOptions.forEach((item) => {
          if (item.name == this.searchForm.workOptionValue) {
            typeName = item.title;
          }
        });
      }
      this.bindSNData.unshift({
        dateTime: new Date().toLocaleString(),
        type: typeName,
        ...this.searchForm,
        code: res.code,
        msg: res.msg
      });
    },
    // 绑定成功数据清除
    successClear() {
      this.pullDownData.SNOption.forEach((item) => {
        this.$set(this.searchForm, item.name, undefined);
      });
      this.$set(this.searchForm, "data", undefined);
      if (!(this.videoSqc || this.agingCheck || this.afterRepair || this.renovateDisassemble)) {
        this.$refs[this.pullDownData.SNOption[0].name][0].focus();
      }
      this.againSN = "";
    },
    // 生成二维码
    createQrcode () {
      // 清空上一次生成的二维码图片
      this.$refs.qrcodeRef.innerHTML = "";
      new QRCode('qrcodeId', {
        width: 200,         // 宽度
        height: 200,        // 高度
        text:  this.QCData,   // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      })
    },
      // 联级选择器改变时触发
      cascaderChange(val, ref) {
        val && this.$refs[ref].toggleDropDownVisible();
      },
    // 用户名下拉菜单
    userCommand(command) {
      if (command == "changePassword") {
        this.changePassword();
      } else if (command == "kickOther") {
        this.kickOtherBtn();
      } else if (command == "logout") {
        this.logOutBtn();
      }
    },
    // 踢除其它登录
    kickOtherBtn() {
      this.$confirm("是否将其它异地登录都踢除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiKickOutOtherLogins();
        this.$message({
          message: res.msg,
          type: res.code == 0 ? "success" : "error"
        });
      });
    },
    // 修改密码
    changePassword() {
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认修改密码
    submitData(title) {
      if (title == "修改用户密码") {
        this.$refs.passwordForm.validate(async valid => {
          if (valid) {
            if (this.passwordForm.password == this.passwordForm.againPwd) {
              const res = await apiUserChangePassword({
                ...this.passwordForm
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.$store.state.userInfo = {};
                removeLocalStorage("userInfo");
                removeSessionStorage("userInfo");
                this.$router.push("/login");
                this.$message({
                  message: "密码修改成功,请重新登录",
                  type: "success"
                });
              }
            } else {
              this.$message({
                type: "error",
                message: "新密码与确认密码不一致"
              });
            }
          } else {
            return false;
          }
        });
      }
    },
    // 密码弹框关闭
    dialogClose() {
      this.$refs.passwordForm.resetFields();
      this.passwordForm = {};
    },
// 退出登录
    logOutBtn() {
      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiUserLogout();
        if (res.code == 0) {
          this.$store.state.userInfo = {};
          this.$store.state.directVisitUrl = "";
          removeLocalStorage("userInfo");
          removeSessionStorage("userInfo");
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出登录"
          });
        }
      });
    }
  },
  activated() {
    this.userInfo = this.$store.state.userInfo;
    this.getFactoryOrg();
    this.getPartTypeList();
    this.getSnReformProductTypeList();
    // 恢复上次选择的功能项（默认过站工序）
    const savedFun = localStorage.getItem('productSystemFun') || 'passStation';
    this.funSwitch(savedFun);
  }
};
</script>

<style lang="less" scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
.productSystem {
  height: 100%;
  background-color: var(--bgPage);
  .main {
    width: 1040px;
    height: 100%;
    margin: 0 auto;
    background-color: var(--bgPanel);
    display: flex;
    flex-direction: column;

    .tipsBox {
      height: 30px;
      padding-left: 10px;
    }
    .tips {
      background-color: var(--tipsBg);
      height: auto;
      min-height: 30px;

      .title {
        font-weight: bold;
        color: #E6A23C;
      }

      .text {
        color: #E6A23C;
      }

      .more {
        cursor: pointer;
      }

      .close {
        float: right;
        line-height: 20px;
        color: #E6A23C;
        cursor: pointer;
      }
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 30px;
      .userDropdown {
        margin-left: 20px;
        cursor: pointer;
      }
      .homeBtn {
        color: var(--themeColor);
        cursor: pointer;
        margin-left: 20px;
      }
      // 功能切换下拉：触发为当前激活功能图标（无激活项时回退产品与服务图标）+ 功能名文字，悬停 title 提示，菜单项同主题色，与主页换肤下拉同款交互；
      // 触发器固定宽度 115px：切换不同功能名（长短不一）时头部位置不位移
      .funSwitcher {
        margin-left: 20px;
        cursor: pointer;
        .funSwitchBtn {
          display: inline-block;
          width: 115px;
          white-space: nowrap;
          color: var(--themeColor);
        }
      }
      .userName {
        color: var(--themeColor);
      }
      .backBtn {
        color: var(--themeColor);
        cursor: pointer;
        margin-left: 20px;
      }
    }
    .content {
      display: flex;
      padding: 10px 40px;
      .el-form {
        flex: 0.6;
        .SNinput {
          /deep/.el-input__inner {
            ime-mode: inactive;
          }
        }
        .textarea {
          /deep/.el-textarea__inner {
            width: 215px;
            font-family: Arial;
        }
        }
      }
      .contentRight {
        flex: 0.4;
        position: relative;
        .proOrderDetail {
          .title {
            width: 80px;
            display: inline-block;
            margin-bottom: 8px;
          }
        }
        .printTagBox {
          position: absolute;
          top: 110px;
          left: 0;
        }
        .statusBox {
          width: 250px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          font-size: 16px;
          color: #fff;
          margin-top: 50px;
        }
        .pass {
          background-color: #67C23A;
        }
        .fail {
          background-color: #f56c6c;
        }
      }
    }
      .pass1 {
        color: #67C23A;
      }
      .fail1 {
        color: #f56c6c;
      }
    .tableBox {
      flex: 1;
      margin-top: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      .el-table {
        width: 92%;
        min-height: 100px;
        margin: 0 auto;
      }
    }
  }
  /deep/.qcDialog {
    .el-dialog__header {
      text-align: center;
    }
    .qrcode {
      padding: 50px;
      img {
        margin: 0 auto;
      }
    }
  }
}
</style>
<style lang="less">
.proOrderPullHidden {
  display: none;
}
</style>